import { LEVEL, MESSAGE } from 'triple-beam';
import { format } from 'winston';
import { messageSymbol } from '../../utils.js';

const setLevel = format((info, { getLevel })=>{
    const level = getLevel?.(info.message, info.level);
    if (level) {
        info.level = level;
        if (info[LEVEL] != null) {
            info[LEVEL] = level;
        }
        if (info[MESSAGE] != null) {
            info[MESSAGE] = messageSymbol(info);
        }
    }
    return info;
});

export { setLevel };
//# sourceMappingURL=setLevel.js.map
